<template>
  <v-flex lg3 md3 xs4>
    <vonap-form-label :label="category.groupCategoryName">
      <kendo-dropdownlist
        v-if="isDropDownList"
        style="width: 100%"
        :disabled="disabled"
        :value="value"
        :data-source="dataSource"
        @change="onChange"
        data-value-field="value"
        data-text-field="text"
      />
      <input
        type="text"
        class="k-textbox"
        v-else
        style="width: 100%"
        @change="onTextBoxChange"
        :value="value"
      />
    </vonap-form-label>
  </v-flex>
</template>

<script>
import VonapFormLabel from '@/components/VonapFormLabel'
import {groupCategoryType} from '../helpers/enums'

export default {
  props: {
    value: {type: [String, Number]},
    dataSource: {type: Array},
    category: {type: Object, required: true},
    disabled: {type: Boolean, required: true},
  },
  computed: {
    isDropDownList() {
      return this.category.groupCategoryTypeId == groupCategoryType.DropDownList
    },
  },
  methods: {
    onChange(e) {
      const {groupCategoryId, groupCategoryName} = this.category
      const value = +e.sender.value()
      this.$emit('change', {groupCategoryId, groupCategoryName, value})
    },
    onTextBoxChange(e) {
      const {groupCategoryId, groupCategoryName} = this.category
      const value = e.target.value
      this.$emit('change', {groupCategoryId, groupCategoryName, value})
    },
  },
  components: {
    VonapFormLabel,
  },
}
</script>
